import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import SupplierNavbar from "./SuppplierNavbar";
import SupplierSidebar from "./SupplierSidebar";
import Axios from "../../../axios/axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Supplier.css";
import { useLocation } from 'react-router-dom';





function SupplierOrdersPage() {
  const { type } = useParams();
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [statusFilter, setStatusFilter] = useState(type || "");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [supplier, setSupplier] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const navigate=useNavigate()
const location = useLocation();

useEffect(() => {
  if (window.innerWidth < 768) {
    setSidebarOpen(false);
  }
}, [location]);

  // Stats state
  const [orderStats, setOrderStats] = useState({
    total: 0,
    requested: 0,
    delivered: 0
  });

  
 useEffect(() => {
  const fetchSupplierOrders = async () => {
    const storedSupplier = sessionStorage.getItem("supplierInfo");
    if (!storedSupplier) return;

    const supplierInfo = JSON.parse(storedSupplier);
    setSupplier(supplierInfo);
    setLoading(true);

    try {
      const config = {
        headers: { "x-supplier-id": supplierInfo.supplierId }
      };

      const response = await Axios.get(`/supplier/${supplierInfo.supplierId}`, {
        ...config,
        params: { 
          status: type || ""
        }
      });

      console.log(response.data);
      

      setOrders(response.data.orders);
      
      const requested = response.data.orders.filter(
        o => o.orderStatus === "quotation requested"
      ).length;
      
      const delivered = response.data.orders.filter(
        o => o.orderStatus === "delivered"
      ).length;

      setOrderStats({
        total: response.data.orders.length,
        requested,
        delivered
      });

    } catch (error) {
      console.error("Error fetching orders:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchSupplierOrders();
}, [type]); 
 
 useEffect(() => {
  let filtered = orders;

  if (statusFilter) {
    filtered = filtered.filter(
      order => order.orderStatus.toLowerCase() === statusFilter.toLowerCase()
    );
  }

  // Apply date filtering
  if (startDate) {
    filtered = filtered.filter(order => {
      const orderDate = new Date(order.orderDate);
      const filterStartDate = new Date(startDate);
      return orderDate >= filterStartDate;
    });
  }

  if (endDate) {
    filtered = filtered.filter(order => {
      const orderDate = new Date(order.orderDate);
      const filterEndDate = new Date(endDate);
      filterEndDate.setHours(23, 59, 59, 999);
      return orderDate <= filterEndDate;
    });
  }

  setFilteredOrders(filtered);
}, [statusFilter, orders, startDate, endDate]);

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="enhanced-body">
      <SupplierNavbar 
        supplier={supplier}
        setSupplier={setSupplier}
        toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
      />
      
      <div className="container-fluid">
        <div className="row">
          {sidebarOpen && (
            <div className="col-md-2">
                                        <SupplierSidebar closeSidebar={() => {
              if (window.innerWidth < 768) setSidebarOpen(false);
            }} />
            </div>
          )}
          
          <div className={sidebarOpen ? "col-md-10" : "col-md-12"}>
            <div className="dashboard-main">
              <h2 className="dashboard-title mb-4">Orders</h2>

              {/* Stats Cards */}
              <div className="row g-4 mb-4">
                <div className="col-md-4">
                  <div className="enhanced-card p-3 text-center">
                    <div className="card-icon-wrapper card-icon-primary">
                      <i className="bi bi-stack fs-3"></i>
                    </div>
                    <h6 className="text-muted mt-2">Total Orders</h6>
                    <div className="card-value">{orderStats.total}</div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="enhanced-card p-3 text-center">
                    <div className="card-icon-wrapper card-icon-secondary">
                      <i className="bi bi-clipboard-data fs-3"></i>
                    </div>
                    <h6 className="text-muted mt-2">Requested Orders</h6>
                    <div className="card-value">{orderStats.requested}</div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="enhanced-card p-3 text-center">
                    <div className="card-icon-wrapper card-icon-success">
                      <i className="bi bi-truck fs-3"></i>
                    </div>
                    <h6 className="text-muted mt-2">Delivered Orders</h6>
                    <div className="card-value">{orderStats.delivered}</div>
                  </div>
                </div>
              </div>

              {/* Filters */}
              <div className="row mb-4 g-3">
                <div className="col-md-3">
                  <input
                    type="date"
                    className="form-control"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </div>
                <div className="col-md-3">
                  <input
                    type="date"
                    className="form-control"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </div>
                <div className="col-md-3">
                  <select
                    className="form-select"
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                  >
                    <option value="">All Statuses</option>
                    <option value="quotation requested">Requested</option>
                    <option value="quotation approved">Approved</option>
                    <option value="delivered">Delivered</option>
                  </select>
                </div>
              </div>

              {/* Orders Table */}
              <div className="table-responsive">
                <table className="table table-bordered table-hover">
                  <thead className="table-light">
                    <tr>
                      <th>Order #</th>
                      <th>Date</th>
                      <th>Status</th>
                      <th>Customer</th>
                      <th>Your Products</th>
                      <th>Your Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredOrders.length > 0 ? (
                      filteredOrders.map((order,index) => (
                        <tr key={order._id}>
                          <td ><Link  to={`/supplier/singleorder/${order._id}`}>{order.orderNumber}</Link></td>
                          <td>
                            {new Date(order.orderDate).toLocaleDateString()}
                          </td>
                          <td>
                              {order.orderStatus}
                          </td>
                          <td>Asiapart Customer {index + 1}</td>
                          <td>
                            <ul className="list-unstyled mb-0">
                              {order.orderItems.map((item, i) => (
                                <li key={i}>
                                  {item.productName} (Qty: {item.quantity})
                                </li>
                              ))}
                            </ul>
                          </td>
                          <td>AED {order.total.toFixed(2)}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center">
                          No orders found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}



export default SupplierOrdersPage;
